import { useRef, useState } from "react";

/**
 *  这段执行空逻辑 以后就可以了 控制台把对应的组件复制过来即可,切记不要覆盖这个utils.js 文件
 * @param {} ignoreList 
 * @param {*} setTabIndex 
 * @returns 
 */
export const useHandleScroll = (ignoreList = [],setTabIndex) => {
  
    const [isScroll, setIsScroll] = useState(true)
    // res.cruuent
    const handleScroll = () => {
    }
    const getBeginnerNavigator = () => {
        return null
    }

    return [isScroll, handleScroll, getBeginnerNavigator]
}